import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'

Vue.use(Vuex)

var URL = 'https://server-sita.konaweselatankab.go.id/'

var STUNT = 'https://statistik-server.konaweselatankab.go.id/'

// var STUNT = 'http://localhost:5020/'

export default new Vuex.Store({
  state: {
    url : {
      URL_APP   : URL,
      URL_LOGIN : STUNT,
      URL_STUNT : STUNT + 'api/v1/apiDataStunting/'
    },
  },
  mutations: {
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'light-blue-4',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
